import React, { useState } from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";
import moment from "moment";
import { toast } from "react-toastify";

import { getDistinctIdentifiersForSampleList, getTemplateAccentStyle, validateCoaName } from "../../../helper";
import SubmitButton from "./SubmitButton";

import { ReactComponent as Calendar } from "../../../../../../assets/images/product/template/CalendarIcon.svg";
import { ReactComponent as Product } from "../../../../../../assets/images/product/template/ProductIconFilled.svg";
import { ReactComponent as EditIcon } from "../../../../../../assets/images/sample-submission/edit.svg";

// import { ReactComponent as Checkmark } from "../../../../../../assets/images/product/template/inputCheckmark.svg";

import "./COASave.css";

export default function COASave({
  handleSaveTemplate,
  toggleSaveModal,
  selectedReports,
  selectedTemplate,
  saveStatus,
  setSaveStatus,
  inline = false,
  coaName: controlledCoaName,
  onCoaNameChange,
  coaNameError: controlledCoaNameError,
  onCoaNameErrorChange,
}) {
  const { name } = selectedTemplate;
  const templateAccentStyle = getTemplateAccentStyle(selectedTemplate);
  const linkReportKeys = selectedReports.link_report_keys;
  const { sample_id: sampleIDArr } = selectedReports.data_fileds;

  const [isEditing, setIsEditing] = useState(true);
  const [internalValue, setInternalValue] = useState(sampleIDArr[0]);
  const [internalNameError, setInternalNameError] = useState("");
  const isControlled = controlledCoaName !== undefined;
  const value = isControlled ? controlledCoaName : internalValue;
  const nameError = controlledCoaNameError !== undefined ? controlledCoaNameError : internalNameError;

  const setNameError = (error) => {
    if (onCoaNameErrorChange) {
      onCoaNameErrorChange(error);
    } else {
      setInternalNameError(error);
    }
  };

  const onChange = (val) => {
    if (isControlled) {
      onCoaNameChange(val);
    } else {
      setInternalValue(val);
    }
    if (inline) {
      const validation = validateCoaName(val);
      setNameError(validation.valid ? "" : validation.message);
    } else if (nameError) {
      setNameError("");
    }
  };

  const handleValidateName = () => {
    const validation = validateCoaName(value);
    if (!validation.valid) {
      setNameError(validation.message);
      toast.error(validation.message);
      return false;
    }
    setNameError("");
    return true;
  };

  const handleCheckAndSaveTemplate = () => {
    if (!handleValidateName()) {
      return;
    }
    if (!inline) {
      setIsEditing(false);
    }
    setSaveStatus("loading");
    handleSaveTemplate({ name: value.trim() });
  };

  return (
    <div className={inline ? "COASave__Container COASave__Container--inline" : "COASave__Container"}>
      {!inline && saveStatus === null && (
        <Button
          htmlType="button"
          className="COASave__DeleteButton"
          aria-label="Close"
          onClick={() => toggleSaveModal(true)}
        >
          <CloseOutlined />
        </Button>
      )}
      <div className="COASave__Header">
        {isEditing ? (
          <div className="COASave__InputParent">
            <label htmlFor="COASave__Input">
              COA Name
            </label>
            <div className="COASave__InputRow">
              <input
                className={`COASave__Input${nameError ? " COASave__Input--error" : ""}`}
                id="COASave__Input"
                type="text"
                placeholder="Enter COA Name"
                value={value}
                onChange={((e) => onChange(e.target.value))}
                autoComplete="off"
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === "Enter" && isEditing) {
                    e.preventDefault();
                    if (inline) {
                      handleValidateName();
                    } else {
                      handleCheckAndSaveTemplate();
                    }
                  }
                }}
              />
              {inline && value && (
                <CloseOutlined
                  className="COASave__Clear"
                  onClick={() => {
                    onChange("");
                  }}
                />
              )}
            </div>
            {nameError && (
              <span className="COASave__InputError">{nameError}</span>
            )}
          </div>
        ) : (
          <>
            <span className="COASave__COAName">{value}</span>
            <EditIcon onClick={() => setIsEditing(true)} className="COASave__InputButton" />
          </>
        )}
      </div>
      <div className="COASave__Body">
        {!inline && (
          <div className="COASaveBody__ReportInfo">
            <div className="COASaveBody__ReportInfoRow">
              <Product width={18} height={18} />
              <span className="LinkedFieldsSpan">
                {getDistinctIdentifiersForSampleList(selectedReports.samples, linkReportKeys).map((identifierArr, sampleIdx) => (
                  <React.Fragment key={sampleIdx}>
                    <span className="LinkedFieldsSpan">
                      {identifierArr.map((val, valIdx) => (
                        <React.Fragment key={valIdx}>
                          <span>
                            {val}
                            {valIdx === identifierArr.length - 1 && sampleIdx < selectedReports.samples.length - 1 && (",")}
                          </span>
                          {valIdx < identifierArr.length - 1 && (<span className="LinkedFieldsDelimiterDot" />)}
                        </React.Fragment>
                      ))}
                    </span>
                  </React.Fragment>
                ))}
              </span>
            </div>
            <div className="COASaveBody__ReportInfoRow">
              <Calendar width={18} height={18} />
              <span>{moment(new Date()).format("MM/DD/yyyy")}</span>
            </div>
            <div
              className="COASaveBody__ReportInfoTag"
              style={templateAccentStyle}
            >
              {name}
            </div>
          </div>
        )}
        {inline && name && (
          <div className="COASaveBody__ReportInfoTag COASaveBody__ReportInfoTag--inline">
            <span
              className="COASaveBody__ReportInfoTagAccent"
              style={templateAccentStyle}
            />
            <span className="COASaveBody__ReportInfoTagName">{name}</span>
          </div>
        )}
        <div className="COASaveBody__Right">
          {saveStatus !== "success" && (
            <SubmitButton
              loading={saveStatus === "loading"}
              disabled={!value.trim() || !!nameError}
              text="Save Report"
              handleSaveTemplate={handleCheckAndSaveTemplate}
            />
          )}
        </div>
      </div>
    </div>
  );
}
